import { render, staticRenderFns } from "./NbSpinner.vue?vue&type=template&id=39f68566&scoped=true&"
import script from "./NbSpinner.vue?vue&type=script&lang=js&"
export * from "./NbSpinner.vue?vue&type=script&lang=js&"
import style0 from "./NbSpinner.vue?vue&type=style&index=0&id=39f68566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f68566",
  null
  
)

export default component.exports